/** zh-CN catalogue `cmd` (W3-09; English: src/core/commands/structure.messages.ts; terms: docs/i18n/glossary.md). */
import type { MessageCatalog } from '../../core/util/types';

const NUDGED = '{nudged, plural, =0 {。} other {，其中 # 个又多移了一个步长，以保持在前一个项目之后。}}';

const catalog: MessageCatalog = {
  ns: 'cmd',
  locale: 'zh-CN',
  messages: {
    badBeat: '该拍数不是有效的位置。',
    'missing.line': '此判定线已不存在。',
    'missing.note': '此音符已不存在。',
    'missing.key': '此关键帧已不存在。',
    'missing.track': '此属性轨道已不存在。',
    'missing.group': '此判定线分组已不存在。',
    'missing.marker': '此标记已不存在。',
    'missing.bpm': '此速度点已不存在。',
    'missing.effect': '此特效已不存在。',
    'missing.video': '此视频已不存在。',
    'missing.asset': '它引用的文件不在项目中。',
    'notes.uiMover':
      '此判定线上的音符将不可见：“{line}”绑定了{element, select, pause {暂停按钮} combonumber {连击数} combo {COMBO 标签} score {分数} bar {进度条} name {曲名} level {难度等级} other {{element}}}的显示。请把音符放到另一条判定线上。',
    'notes.badField':
      '{field, select, x {X 位置} speed {速度} yOffset {高度偏移} size {宽度} alpha {不透明度} visibleTime {出现时间} judgeArea {判定宽度} tint {染色} tintHitEffects {打击特效染色} hitsound {打击音} above {方向} fake {假键} other {{field}}}的值无效。',
    'notes.beforeStart': '音符不能放置或移动到第 0 拍之前。',
    'notes.holdEnd': 'Hold 的结束必须晚于开始。',
    'notes.holdLength': 'Hold 的长度必须大于零。',
    'notes.exprFailed': '表达式没有为第 {index} 个音符（共 {count} 个）得到有效的数字。',
    'notes.gridCount': 'X 网格需要 2 到 1351 条线。',
    'notes.snapDiv': '节拍网格必须将一拍分为 1 到 1920 份。',
    'notes.zeroHoldsGrown': '{count, plural, other {# 个零长度的 Hold}}已变为一个步长（1/{div} 拍）的 Hold。',
    'lines.badPosition': '位置必须是有限的数字。',
    'lines.badTime': '让判定线保持原位的时间不是有效的时间。',
    'lines.parentCycle': '“{line}”不能跟随“{parent}”：那样“{line}”会成为自己的祖先。',
    'lines.keepPlaceAnimated':
      '“{line}”随时间运动，因此只转换了它在 {beat} 处的关键帧以保持原位。请检查该关键帧附近的运动。',
    'lines.unlinkedForEdit': '已解除被修改关键帧附近区段的绑定，因此与之绑定的区段保持原样。',
    'lines.uiMoverNotes':
      '请先把它的{count, plural, other { # 个音符}}移到另一条判定线上：绑定了显示元素的判定线上的音符永远不会被绘制。',
    'lines.uiElementRequired': '请选择此判定线要绑定的显示元素。',
    'lines.uiMoverAlphaAdded': '已为“{line}”添加 100% 不透明度：没有不透明度关键帧时，该显示元素在 Phira 中将不可见。',
    'lines.textureRequired': '请为此判定线选择一张图片。',
    'lines.notImage': '“{path}”不是图片。',
    'lines.notGif': '“{path}”不是 Phira 能播放的 GIF。',
    'lines.gifAutoLoopNeedsGif': '“自动播放”需要判定线贴图是 GIF 图片。',
    'lines.gifDataRemoved':
      '已移除“{line}”的 GIF 播放：其贴图已不是 GIF，而在其他图片类型上带有 GIF 播放的谱面 Phira 无法加载。',
    'lines.orderInvalid': '新的判定线顺序必须列出现有的判定线，且每条只出现一次。',
    'lines.zOrderRange': '绘制顺序必须是 -2147483648 到 2147483647 之间的整数。',
    'lines.countRange': '一次请创建 1 到 {max} 条判定线。',
    'lines.controlEmpty': '距离控制至少需要一个点。',
    'lines.controlValue': '每个距离控制点都需要有限的数字。',
    'lines.controlEasing': '距离控制点使用 0 到 255 的 RPE 缓动编号。',
    'lines.controlOrder': '距离控制点必须按距离排序。',
    'lines.inclineInvalid': '音符倾斜必须是有限的度数。',
    'lines.inclineReplaced': '带动画的音符倾斜已被替换为单个值：Phira 只使用谱面开始时的倾斜。',
    'lines.groupName': '分组需要一个名称。',
    'lines.groupOrder': '分组位置必须是 1 到 {max} 之间的整数。位置 0 是“默认”分组，存放没有分组的判定线。',
    'text.notText': '此关键帧不在文字轨道上。',
    'text.noSegment': '这是最后一个文字关键帧，没有区段从这里开始。请先在它之后添加一个关键帧。',
    'text.emptyText': '“逐字显示”和“擦除”需要有要显示的文字。',
    'text.extendNeedsPrefix': '“扩展 / 收缩”需要一段文字以另一段开头，且两者不同。',
    'text.counterNotNumeric': '计数器两端都需要是普通数字。请把“Score:”这样的标签放在另一条文字线上。',
    'text.easeReplaced': '缓动已改为线性：用超出起点或终点的缓动来逐字显示或擦除文字时，Phira 会崩溃。',
    'text.unlinked': '已解除该文字区段与其绑定区段的绑定，因此它们保留各自的文字。',
    'tempo.bpmInvalid': '速度必须是大于 0 的每分钟拍数。',
    'tempo.beforeStart': '速度变化必须在第 0 拍之后。请改为修改第 0 拍的速度。',
    'tempo.pointExists': '{beat} 处已有一个速度变化。',
    'tempo.firstPointFixed': '第 0 拍的速度点不能移动；只能修改它的速度。',
    'tempo.firstPointDelete': '第 0 拍的速度点不能删除；请改为修改它的速度。',
    'tempo.pointsCollide': '使用“保持时间”时，此速度变化会落在另一个速度变化上。',
    'tempo.outOfRange': '此更改会把部分项目移出谱面能存储的拍数范围。',
    'tempo.snapped': `已重新计时 {retimed, plural, other {# 个项目}}；{snapped, plural, other {# 个位置}}已取整到 1/1920 拍${NUDGED}`,
    'timing.offsetInvalid': '偏移必须是有限的毫秒数。',
    'timing.folded': 'Phira 针对此谱面的 {ms} 毫秒调整已并入谱面偏移。',
    'timing.meterInvalid': '每个拍号标记都需要位于第 0 拍或之后的不同拍数，且每小节拍数大于 0。',
    'timing.meterStartAdded':
      '小节线从第 0 拍开始计数，因此已在那里添加了每小节 {beatsPerBar, plural, other {# 拍}}的拍号标记。',
    'markers.beforeStart': '标记不能放在第 0 拍之前。',
    'meta.previewStart': '曲目预览必须从 0 秒或之后开始。',
    'meta.previewEnd': '曲目预览的结束必须晚于开始。',
    'meta.difficulty': '难度必须是大于或等于 0 的数字。',
    'meta.rpeId': 'RPE 谱面 ID 只能包含数字。',
    'meta.tags': '标签必须是文字。',
    'pkg.invalid':
      '{field, select, aspectRatio {宽高比必须是大于 0 的数字。} backgroundDim {背景暗度必须在 0 到 1 之间。} lineLength {判定线长度必须是大于 0 的数字。} speedBakeTolPx {流速烘焙容差必须是大于 0 的数字。} rpeVersion {RPEVersion 必须是大于或等于 0 的整数。} infoOffsetSec {info.yml 的偏移必须是有限的秒数。} other {设置项 {field} 的值无效。}}',
    'speed.ignoredDropped': '已移除 {count, plural, other {# 条 Phira 会忽略的流速曲线}}；音符的移动与之前相同。',
    'speed.ignoredApplied': '{count, plural, other {# 条 Phira 原本会忽略的流速曲线}}现在生效了。',
    'speed.ignoredSkipped': '{count, plural, other {# 条流速曲线}}无法应用（自定义曲线会使 Phira 崩溃），已保持线性。',
    'problems.badKey': '无法忽略此问题：它没有 ID。',
    'export.badRecord': '导出记录不完整。',
    'assets.badId': '该文件没有内容 ID。',
    'assets.badSize': '文件大小无效。',
    'assets.renamed': '文件“{from}”已作为“{to}”添加，以便 Phira 能加载它。',
    'assets.inUse':
      '“{path}”在谱面中被使用了 {count, plural, other {# 次}}。请先移除这些使用处，或将文件与它们一起移除。',
    'assets.referencesRemoved':
      '已随文件移除“{path}”的 {count, plural, other {# 处使用}}（使用它的特效和视频已被删除）。',
    'assets.nonAscii': '谱面包中的文件名只能使用纯 ASCII 字母、数字和符号。',
    'assets.badPath':
      '“{path}”不能用作文件名：{reason, select, empty {路径为空} leadingSlash {它以“/”开头} backslash {它包含反斜杠} emptyFolder {它有一个空的文件夹名} dotSegment {它包含作为文件夹的“.”或“..”} reserved {Phira 保留了此名称} clickPng {Phira 会把以 click.png 结尾的文件当作皮肤文件} builtinHitsound {对这个打击音文件名 Phira 会播放自己的音效} other {{reason}}}。',
    'assets.pathTaken': '项目中已有另一个名为“{path}”的文件。',
    'assets.notAudio': '“{path}”不是音频文件。',
    'assets.builtinHitsoundName':
      '“{path}”不能作为自定义打击音：对于这个文件名，Phira 会播放自己的内置音效。请先重命名文件，例如放入“sfx/{path}”这样的文件夹。',
    'effects.range': '特效的结束必须晚于开始。',
    'effects.notShader': '“{path}”不是着色器文件。',
    'effects.unknownShader': 'Phira 没有名为“{name}”的内置特效。',
    'effects.varName': '“{name}”不能作为着色器变量名：请使用字母、数字和“_”，且不以数字开头。',
    'effects.varValue': '“{name}”的值与其类型不符。',
    'effects.varTrack': '“{name}”的关键帧不属于此特效。',
    'effects.orderInvalid': '新的特效顺序必须列出现有的特效，且每个只出现一次。',
    'videos.notVideo': '“{path}”不是视频。',
    'videos.scale': '请选择视频填满屏幕的方式：裁剪填满、完整显示或拉伸。',
    'videos.varValue': '视频的{which, select, alpha {不透明度} dim {暗度} other {{which}}}必须是有限的数字。',
    'videos.varTrack': '这些{which, select, alpha {不透明度} dim {暗度} other {{which}}}关键帧不属于此视频。',
    'merge.noLines': '请至少选择一条要合并的判定线。',
    'merge.lineMissing': '要合并的谱面中没有判定线 {id}。',
    'merge.negativeOffset': '合并的判定线必须从第 0 拍或之后开始。',
    'merge.outOfRange': '合并的判定线最终会超出谱面能存储的拍数范围。',
    'merge.parentsDetached': '{count, plural, other {# 条合并的判定线}}失去了父线：父线没有被合并。',
    'merge.leadIns': '{count, plural, other {# 个合并的属性}}现在晚于第 0 拍开始，开始之前保持中性值。',
    'merge.align': '请选择合并的判定线在时间上如何放置：按拍数、按曲目时间或自动。',
    'merge.offsetDiffers':
      '两张谱面使用相同的速度，因此合并的音符保留了拍数并仍在节拍网格上。但两张谱面的偏移不同，因此它们现在比在原谱面中{direction, select, later {推迟} other {提前}} {ms, number} 毫秒播放。（速度不同的谱面会改为按曲目时间合并，以保持其时间。）如果听起来不对，请在时间上平移它们，或按曲目时间合并。',
    'merge.tempoDiffers':
      '合并的音符保留了拍数，但两张谱面的速度不同，因此它们播放的时间与在原谱面中不同。按曲目时间合并可以保持其时间。',
    'merge.snapped': `为适应此谱面的速度，{count, plural, other {# 个位置}}已取整到 1/1920 拍${NUDGED}`,
  },
};

export default catalog;
